import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE,
} from '../store/types';
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { onValue, get } from 'firebase/database';

export const getEstimate = bookingData => async dispatch => {
  const { settingsRef, singleUserRef } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });

  let res = bookingData.routeDetails;

  if (res) {
    let points = Polyline.decode(res.polylinePoints);

    let waypoints = points.map(point => {
      return {
        latitude: point[0],
        longitude: point[1],
      };
    });

    onValue(
      settingsRef,
      async settingdata => {
        let settings = settingdata.val();
        let distance = settings.convert_to_mile
          ? res.distance_in_km / 1.609344
          : res.distance_in_km;

        // Fetch customer pricing if customer ID is provided
        let customerPricing = null;
        if (bookingData.customerId) {
          try {
            const customerSnapshot = await get(
              singleUserRef(bookingData.customerId)
            );
            const customerData = customerSnapshot.val();
            if (customerData && customerData.customPricing) {
              customerPricing = customerData.customPricing;
            }
          } catch (error) {
            console.log('Error fetching customer pricing:', error);
            // Continue with standard pricing if there's an error
          }
        }

        // Fetch driver pricing if driver ID is provided
        let driverPricing = null;
        if (bookingData.driverId) {
          try {
            const driverSnapshot = await get(
              singleUserRef(bookingData.driverId)
            );
            const driverData = driverSnapshot.val();
            if (driverData && driverData.driverCustomPricing) {
              driverPricing = driverData.driverCustomPricing;
            }
          } catch (error) {
            console.log('Error fetching driver pricing:', error);
            // Continue with standard pricing if there's an error
          }
        }

        let {
          totalCost,
          grandTotal,
          convenience_fees,
          customPricingApplied,
          driverCustomPricingApplied,
          originalRates,
        } = FareCalculator(
          distance,
          res.time_in_secs,
          bookingData.carDetails,
          bookingData.instructionData,
          settings.decimal,
          customerPricing,
          driverPricing
        );

        dispatch({
          type: FETCH_ESTIMATE_SUCCESS,
          payload: {
            pickup: bookingData.pickup,
            drop: bookingData.drop,
            carDetails: bookingData.carDetails,
            instructionData: bookingData.instructionData,
            estimateDistance: parseFloat(distance).toFixed(settings.decimal),
            fareCost: totalCost
              ? parseFloat(totalCost).toFixed(settings.decimal)
              : 0,
            estimateFare: grandTotal
              ? parseFloat(grandTotal).toFixed(settings.decimal)
              : 0,
            estimateTime: res.time_in_secs,
            convenience_fees: convenience_fees
              ? parseFloat(convenience_fees).toFixed(settings.decimal)
              : 0,
            waypoints: waypoints,
            // Add custom pricing info
            customPricingApplied: customPricingApplied,
            driverCustomPricingApplied: driverCustomPricingApplied,
            customerPricing: customerPricing,
            driverPricing: driverPricing,
            originalRates: originalRates,
          },
        });
      },
      { onlyOnce: true }
    );
  } else {
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: 'No Route Found',
    });
  }
};

export const clearEstimate = () => dispatch => {
  dispatch({
    type: CLEAR_ESTIMATE,
    payload: null,
  });
};
